import { PostList } from "src/api/client-api/post/types/postList.types";

export type MeasuredPostCandidate = Pick<PostList, "campaign" | "isLocked" | "olapScores">;

export const getMeasuredValueByCampaignId = (
    posts: MeasuredPostCandidate[] | undefined,
    scoreId: number,
    excludedCampaignId?: number,
): Map<number, number> => {
    const measuredValues = new Map<number, number>();

    for (const post of posts ?? []) {
        const campaignId = post.campaign?.id;
        if (campaignId === undefined || campaignId === excludedCampaignId) continue;
        if (post.isLocked !== true) continue;

        const value = post.olapScores?.[scoreId]?.score.value;
        if (typeof value === "number") {
            measuredValues.set(campaignId, value);
        }
    }

    return measuredValues;
};

export type MeasuredBar = { label: string; value: number };

export const splitMeasuredYears = <T extends { campaign?: { id: number; label: string } }>(
    simulationPosts: T[],
    measuredValueByCampaignId: Map<number, number>,
): { measuredBars: MeasuredBar[]; projectedPosts: T[] } => {
    const measuredBars: MeasuredBar[] = [];
    let firstProjectedIndex = 0;

    for (const post of simulationPosts) {
        const campaign = post.campaign;
        const value = campaign === undefined ? undefined : measuredValueByCampaignId.get(campaign.id);
        if (campaign === undefined || value === undefined) break;

        measuredBars.push({ label: campaign.label, value });
        firstProjectedIndex += 1;
    }

    return { measuredBars, projectedPosts: simulationPosts.slice(firstProjectedIndex) };
};
